class CardProduct extends HTMLElement {
    constructor() {
        super();

        this.productUrl = this.dataset.productUrl;
        /* this.sectionId = this.dataset.sectionId; */
        this.variantId = this.dataset.currentVariantId;
        this.variantIds = this.dataset.variantIds;
        this.onCardUpdate = this.handleCardUpdate.bind(this);
        this.onCartRefresh = this.handleCartRefresh.bind(this);
    }

    connectedCallback() {
       this.addEventListener('pb:card:update', this.onCardUpdate);
       document.addEventListener('pb:cart:refresh', this.onCartRefresh);
    }

    disconnectedCallback() {
      this.removeEventListener('pb:card:update', this.onCardUpdate);
      document.removeEventListener('pb:cart:refresh', this.onCartRefresh);
    }

    handleCardUpdate(event) {
      const detail = event.detail; 
      const { type, quantity, variant_id, product_id, product_title, line_index } = detail;

      if(type === 'add-to-cart'){
        this.addToCart(quantity, variant_id, product_title);
      }

      if(type === 'update-quantity'){
        this.updateQuantity(quantity, variant_id, product_title);
      }
    }

    handleCartRefresh(event) {
      const { variantId } = event.detail || {};

      // Convertir el string de IDs separados por comas a un array de números
      const variantIdsArray = this.variantIds.split(',').map(id => Number(id));
      
      // Verificar si el variantId del evento está en el array de variantes de este producto
      if (!variantId || !variantIdsArray.includes(Number(variantId))) {
        return; // No es una variante relacionada con este producto
      }

      // Aquí actualizamos solo la card que tanga cambios
      this.renderCards();
    }


    addToCart(quantity, variant_id, product_title){
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ quantity, id: variant_id })
      })
        .then(async res => {
        if (!res.ok) {
          // Shopify devuelve error JSON en muchos casos, así que lo parseamos
          const err = await res.json().catch(() => ({}));
          throw err;
        }
        return res.json();
      })
        .then(data => {
          window.showToast(`${window.globalTranslations.addToCart}: ${product_title}`);
        })
        .catch(err => {
          window.showToast(err?.responseJSON?.description || 'Error al añadir', 'error');
        })
        .finally(() => {
          console.log('CART:REFRESH 11')

          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { variantId: variant_id } }));
        });
    }

    updateQuantity(quantity, variant_id, product_title){
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ quantity, id: variant_id })
      })
        .then(async res => {
        if (!res.ok) {
          // Shopify devuelve error JSON en muchos casos, así que lo parseamos
          const err = await res.json().catch(() => ({}));
          throw err;
        }
        return res.json();
      })
        .then(data => {
          window.showToast(`${window.globalTranslations.updateToCart}: ${product_title}`);
        })
        .catch(err => {
          window.showToast(err?.responseJSON?.description || 'Error al añadir', 'error');
        })
        .finally(() => {
          console.log('CART:REFRESH 6')
          //document.dispatchEvent(new CustomEvent('cart:refresh'));
          //falle o actualice renderizamos para mostrar nuevos datos o quitar el block de los botones
          
           document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { variantId: variant_id } }));
        });
    }

    renderCards() {
      // Usamos la URL del producto en lugar de la URL actual
      const baseUrl = this.productUrl;
      
      // Crear un objeto URL para manipular la URL de manera segura
      const url = new URL(baseUrl, window.location.href);
      
      // Preservar parámetros de consulta existentes de la URL actual
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.forEach((value, key) => {
        // Solo añadir si no existe ya en la URL del producto
        if (!url.searchParams.has(key)) {
          if(key == 'country') return;
          url.searchParams.set(key, value);
        }
      });
      
      // Especificar que queremos la sección new-card-product
      url.searchParams.set('section_id', 'new-card-product');

      fetch(url.toString())
        .then(res => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Extraer el contenido de la tarjeta de producto
          const newCardContent = doc.querySelector('card-product');
          
          if (!newCardContent) {
            console.warn('No se encontró el contenido de la tarjeta en la respuesta');
            return;
          }
          
          // Buscar todas las instancias de esta tarjeta en la página actual
          const currentCards = document.querySelectorAll(`.card-${this.variantId}`);
          
          if (!currentCards.length) {
            console.warn(`No se encontraron tarjetas con clase .card-${this.variantId} en la página`);
            return;
          }
          
          // Actualizar cada instancia de la tarjeta con el nuevo contenido
          currentCards.forEach(card => {
            // Preservamos el elemento card-product pero actualizamos su contenido interno
            // para mantener los event listeners
            const innerContent = newCardContent.innerHTML;
            card.innerHTML = innerContent;
          });
          
          console.log(`Actualizadas ${currentCards.length} tarjetas para la variante ${this.variantId}`);
        })
        .catch(err => console.error('Error al renderizar tarjeta de producto:', err));
    }
}

customElements.define('card-product', CardProduct);

class PdpButtonContent extends CardProduct {
    constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
    }

    renderCards() {

      //TODO: revisar esta funcion parece estar ejecutandose de MainSearch, pero al desabilitar el pdp deja de actualizar quantity

      // Construimos URL base manteniendo query params existentes
      const url = new URL(window.location.href);

      // Añadimos o reemplazamos el parámetro section_id
      url.searchParams.set('section_id', this.sectionId);
      
      fetch(url.toString())
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // cards en el HTML nuevo (respuesta)
          const newCards = doc.querySelectorAll(`.pdp-${this.variantId}`);
          // cards actuales en la página
          const currentCards = document.querySelectorAll(`.pdp-${this.variantId}`);

          if (!newCards.length || !currentCards.length) return;

          currentCards.forEach((card, index) => {
            // si hay menos nuevos que actuales, reutilizamos el primero
            const source = newCards[index] || newCards[0];
            card.innerHTML = source.innerHTML;
          });

          //REVISADO: ESTE HACE QUE AL SUMAR O QUITAR ITEMS DEL CARD NORMAL SE ACTUALICE EL CART
          
        })
        .catch(err => console.error('Error al renderizar sección:', err));
    }
}

customElements.define('pdp-button-content', PdpButtonContent);